import {
  Autocomplete,
  TextField,
  Button,
  Box,
  InputAdornment,
  Dialog,
  DialogContent,
  MenuItem,
  DialogActions,
  Select,
  Typography,
} from "@mui/material";
import "./SitePages.css";
import CustomTable from "../../../CustomTable/CustomTable";
import tableHeadCells from "./tableHeadCells.json";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useEffect, useMemo } from "react";
import { WebsiteWithUuid } from "../../../../data/website/Website";
import { PageGroup } from "../../../../data/sitePages/SitePage";
import AddIcon from "@mui/icons-material/Add";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SitePagesFilter from "./SitePagesFilter";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSelector } from "react-redux";
import {
  selectUserData,
  setDisplayErrorSnackBar,
} from "../../../../features/userSlice";
import store from "../../../../store";

export interface SitePagesProps {
  sitePages: any;
  selectedSite: WebsiteWithUuid;
  handleCreatePage: any;
  pageGroups: PageGroup[] | undefined;
  handelCreatePagePopUp: any;
  openCreateNewPage: boolean;
  setOpenCreateNewPage: any;
  oauthTokenHeader: string;
  setDuplicatePageResponse: any;
  duplicatePageResponse: any;
  deletePageData: any;
  setDeletePageData: any;
  // Function to set the selected option for group
  // Function to set the selected option for edit
  setSelectedOptionEdit: React.Dispatch<React.SetStateAction<string>>;
  selectedOptionEdit: string;
  pageGroupApiCall: any;
  pageGroupForAssign: any;
  setSelectedPageForAssign: any;
  setPageDetails: any;
  pageDetails: any;
  assignPageGroup: any;
  setIsMetaUpdated: any;
  isMetaUpdated: any;
}

export default function SitePages({
  sitePages,
  selectedSite,
  handleCreatePage,
  pageGroups,
  handelCreatePagePopUp,
  openCreateNewPage,
  setOpenCreateNewPage,
  oauthTokenHeader,
  duplicatePageResponse,
  setDuplicatePageResponse,
  deletePageData,
  setDeletePageData,
  setSelectedOptionEdit,
  selectedOptionEdit,
  pageGroupApiCall,
  pageGroupForAssign,
  setPageDetails,
  pageDetails,
  assignPageGroup,
  setIsMetaUpdated,
  isMetaUpdated,
}: SitePagesProps) {
  const navigate = useNavigate();
  const [selectedPage] = useState<string | undefined>();
  const [pageTitle, setPageTitle] = useState<string>();
  const [pageName, setPageName] = useState<string>();
  const [pageGroup, setPageGroup] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [, setErrorValidate] = useState<string>();
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  // tableProps states
  const [editedSelected, setEditedSelected] = useState(false);
  const [inputValueGroup, setInputValueGroup] = useState("");
  const [inputValueEdited, setInputValueEdited] = useState("");
  const [inputValueStatus, setInputValueStatus] = useState("");
  const [pageOwnerSearchTerm, setPageOwnerSearchTerm] = useState("");
  const [selectedPageOwners, setSelectedPageOwners] = useState<string[]>([]);
  const [assignPageGroupDialogOpen, setAssignPageGroupDialogOpen] =
    useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(""); // input value for the search
  const [confirmedSearchText, setConfirmedSearchText] = useState("");
  const [isOpen, setIsOpen] = useState(false); // dropdown open state
  const [setIsAssignPageGroupOpen] = useState(false);
  const [isAssignPageGroupEnable, setIsAssignPageGroupEnable] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [jumpEditUrl, setJumpEditUrl] = useState("");

  const originalSitePages = useMemo(() => {
    return sitePages || [];
  }, [sitePages]);
  const [isCheckboxCheckedArray, setIsCheckboxCheckedArray] = useState(
    Array(originalSitePages ? originalSitePages.length : 0).fill(false)
  );
  const userData = useSelector(selectUserData);

  const siteUid = selectedSite && Object.keys(selectedSite)[0];
  const hasAssignPagesToGroupsPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "assign_pages_to_groups"
  );
  const hasCreatePagePermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "create_new_pages"
  );
  const filteredSitePages = sitePages?.filter(
    (page: any) => page?.shared_uid !== null && page?.post_status !== "bin"
  );

  useEffect(() => {
    const selectedPageId = searchParams.get("pageTitle");

    if (!selectedPageId) return; // Exit early if there's no selected page ID

    if (filteredSitePages && filteredSitePages.length > 0) {
      const existingOption = filteredSitePages.find(
        (page: any) => String(page.post_id) === selectedPageId
      );

      if (existingOption) {
        setSelectedOption(existingOption);
        setSearchText(existingOption.post_title);
        setConfirmedSearchText(existingOption.post_title);
      }
    }
    // eslint-disable-next-line
  }, []); // Depend on `sitePages` instead of `filteredSitePages`

  const tableProps = {
    sitePages,
    headCells: tableHeadCells,
    selectedPage,
    selectedSite,
    oauthTokenHeader,
    siteUid,
    duplicatePageResponse,
    setDuplicatePageResponse,
    deletePageData,
    setDeletePageData,
    selectedOptionEdit,
    setSelectedOptionEdit,
    editedSelected,
    setEditedSelected,
    inputValueGroup,
    setInputValueGroup,
    inputValueEdited,
    setInputValueEdited,
    inputValueStatus,
    setInputValueStatus,
    pageOwnerSearchTerm,
    setPageOwnerSearchTerm,
    selectedPageOwners,
    setSelectedPageOwners,
    searchText: confirmedSearchText,
    setSearchText,
    setIsAssignPageGroupOpen,
    setIsAssignPageGroupEnable,
    setPageDetails,
    setIsCheckboxCheckedArray,
    isCheckboxCheckedArray,
    setConfirmedSearchText,
    assignPageGroup,
    pageGroupForAssign,
    pageGroups,
    pageDetails,
    assignPageGroupDialogOpen,
    setAssignPageGroupDialogOpen,
    setIsMetaUpdated,
    isMetaUpdated,
    setSelectedOption,
  };

  useEffect(() => {
    const deletedPages = sessionStorage.getItem("deletedPages");
    if (deletedPages) {
      const deletedPagesArray = JSON.parse(deletedPages);
      if (deletedPagesArray.includes(pageTitle)) {
        setShowErrorDialog(true);
      }
    }
  }, [pageTitle]);

  const handleClose = () => {
    setOpenCreateNewPage(false);
    setPageName("");
    setPageTitle("");
    setPageGroup("");
    setErrorValidate("");
  };

  const handleRetry = () => {
    setShowErrorDialog(false);
    setOpenCreateNewPage(true);
  };

  const validate = () => {
    if (!pageTitle || !pageGroup) {
      setErrorValidate("Missing Mandatory Fields");
    } else if (
      sitePages?.records?.some((post: any) => post?.post_title === pageTitle)
    ) {
      setErrorValidate("Duplicate Page Title");
      setShowErrorDialog(true);
    } else {
      handleCreatePage(pageTitle, pageName, pageGroup, setShowErrorDialog);
      handleClose();
    }
  };

  const openAssignPageGroupDialog = () => {
    pageGroupApiCall();
    setAssignPageGroupDialogOpen(true);
  };

  const handleSelectPage = (_: unknown, option: any) => {
    if (option?.isShowAllOption) {
      // When "Show all" is clicked, apply the current search text as filter
      setConfirmedSearchText(searchText.trim());
      setSelectedOption(null);
      setIsOpen(false);

      // Clear the pageTitle param since we're showing filtered results, not a specific page
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("pageTitle");
      newParams.set("page", "0"); // Reset to first page
      setSearchParams(newParams);
      return;
    }

    if (option) {
      setConfirmedSearchText(option.post_title || option.post_name);
      setSelectedOption(option);
      setSearchText(option.post_title || option.post_name);

      const newParams = new URLSearchParams(searchParams);
      newParams.set("pageTitle", String(option.post_id));
      newParams.set("page", "0");
      setSearchParams(newParams);
    } else {
      setSelectedOption(null);
      setSearchText("");
      setConfirmedSearchText("");
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("pageTitle");
      setSearchParams(newParams);
    }
    setIsOpen(false);
  };

  //-- Function to get the post status from the URL
  function getPostStatusFromUrl(urlString: any, records: any) {
    const url = new URL(urlString);
    const searchParams = url.searchParams;

    // Check for 'original_path' parameter
    if (searchParams.has("original_path")) {
      const slug = searchParams.get("original_path");
      const post = records.find((record: any) => record.post_name === slug);
      return post ? post.post_status : null;
    }

    // Extract slug from pathname
    const pathname = url.pathname.replace(/^\/+|\/+$/g, ""); // Removes leading/trailing slashes
    const post = records.find((record: any) => record.post_name === pathname);
    return post ? post.post_status : null;
  }

  //-- Function to navigate to the edit page based on the Valid URL
  const handleJumpToEdit = () => {
    if (filteredSitePages?.length === 0) return;
    try {
      const url = new URL(jumpEditUrl);
      const params = new URLSearchParams(url.search);
      const originalPath = params.get("original_path");
      const cleanUrl = url.origin + url.pathname;
      const postNameFromPath = url.pathname.replace(/^\/+|\/+$/g, "");

      let selectedPage: any;
      const postStatus = getPostStatusFromUrl(jumpEditUrl, filteredSitePages);

      if (postStatus === "draft") {
        selectedPage = filteredSitePages?.find(
          (page: any) => page.post_name === originalPath
        );
      } else if (postStatus === "pending") {
        selectedPage = filteredSitePages?.find(
          (page: any) => page.post_name === postNameFromPath
        );
      } else if (postStatus === "publish") {
        selectedPage = filteredSitePages?.find(
          (page: any) => page.preview_link === cleanUrl
        );
      }

      if (selectedPage?.shared_uid) {
        const editUrl = `/assets/page_builder/edit?selectedSite=${siteUid}&selectedPage=${selectedPage.shared_uid}`;
        navigate(editUrl);
      } else {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: `No matching page found for ${jumpEditUrl}. Please enter the valid URL`,
            type: "error",
          })
        );
      }
    } catch (error) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: `No matching page found for ${jumpEditUrl}. Please enter the valid URL`,
          type: "error",
        })
      );
    }
  };

  return (
    <>
      <div>
        <div className="card-bulk-actions-1-mediu1">
          <div className="cardheader1">
            <div className="content9">
              <h5 className="header2">Pages</h5>
              <div className="subheader3">
                Edit a specific page or modify multiple pages settings
              </div>
            </div>
            <Box>
              <TextField
                id="outlined-required"
                color="secondary"
                label="Jump to Edit:"
                value={jumpEditUrl}
                size="small"
                onChange={(e) => setJumpEditUrl(e.target.value)}
                placeholder="Paste the URL on the page you want to edit"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                sx={{ width: "340px", marginRight: "10px" }}
              />
              <Button
                onClick={() => handleJumpToEdit()}
                //variant="contained"
                color="secondary"
                disabled={!jumpEditUrl}
                endIcon={<AutoFixHighIcon />}
                data-tracker="371"
              />
            </Box>
          </div>
          <div className="custom-table-toolbar1">
            <div className="queries2">
              <Autocomplete
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                freeSolo={false}
                disablePortal={false}
                data-tracker="4"
                disabled={!filteredSitePages}
                options={
                  filteredSitePages?.length > 0
                    ? filteredSitePages.map((item: any) => ({
                        post_title: item.post_title,
                        post_name: item.post_name,
                        post_id: item.post_id,
                      }))
                    : []
                }
                value={selectedOption}
                id="combo-box-demo"
                getOptionLabel={(option: any) => {
                  if (option.isShowAllOption) return ""; // Empty string for "Show all" option
                  return option.post_title || option.post_name || "";
                }}
                onChange={handleSelectPage}
                sx={{ width: "100%", maxWidth: "400px" }}
                color="secondary"
                onInputChange={(_: unknown, value: any, reason) => {
                  // Update search text for all reasons except when clearing due to selection
                  if (reason !== "reset" || !selectedOption) {
                    setSearchText(value);
                  }
                }}
                filterOptions={(options: any, { inputValue }) => {
                  if (!inputValue.trim()) {
                    return options.slice(0, 1000); // Show first 1000 when no input
                  }

                  const searchTerm = inputValue.toLowerCase().trim();
                  const filtered = options.filter((option: any) => {
                    const postName = option.post_name?.toLowerCase() || "";
                    const postTitle = option.post_title?.toLowerCase() || "";
                    return (
                      postName.includes(searchTerm) ||
                      postTitle.includes(searchTerm)
                    );
                  });

                  // Add "Show all" option if there are more than 1 results
                  if (filtered.length >= 1) {
                    return [
                      ...filtered.slice(0, 5), // Show first 1 match
                      {
                        isShowAllOption: true,
                        post_title: `Show all ${filtered.length} results for "${inputValue}"`,
                        post_name: "",
                        post_id: "show-all",
                      },
                    ];
                  }

                  return filtered;
                }}
                renderOption={(props, option) => {
                  if (option.isShowAllOption) {
                    return (
                      <li
                        {...props}
                        key="show-all-option"
                        style={{
                          textAlign: "center",
                          display: "block",
                          backgroundColor: "#f5f5f5",
                          fontStyle: "italic",
                          borderTop: "1px solid #e0e0e0",
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="primary"
                          fontWeight={500}
                        >
                          {option.post_title}
                        </Typography>
                      </li>
                    );
                  }
                  return (
                    <li
                      {...props}
                      key={option.post_id}
                      style={{ textAlign: "left", display: "block" }}
                    >
                      <Typography variant="body1" fontWeight={500}>
                        {option.post_title || "Unnamed"}
                      </Typography>
                      {option.post_name && (
                        <Typography variant="body2" color="text.secondary">
                          {option.post_name}
                        </Typography>
                      )}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Page Name or Title"
                    color="secondary"
                    // Show filtered indicator when we have a confirmed search but no specific selection
                    helperText={
                      confirmedSearchText && !selectedOption
                        ? `Showing results filtered by: "${confirmedSearchText}"`
                        : ""
                    }
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        const searchTerm = searchText.trim().toLowerCase();

                        if (!searchTerm) {
                          setIsOpen(false);
                          return;
                        }

                        const currentFilteredOptions = filteredSitePages.filter(
                          (option: any) => {
                            const postName =
                              option.post_name?.toLowerCase() || "";
                            const postTitle =
                              option.post_title?.toLowerCase() || "";
                            return (
                              postName.includes(searchTerm) ||
                              postTitle.includes(searchTerm)
                            );
                          }
                        );

                        if (currentFilteredOptions.length >= 1) {
                          // If there are more than 1 results, trigger the "Show all" behavior
                          setConfirmedSearchText(searchText.trim());
                          setSelectedOption(null);

                          const newParams = new URLSearchParams(searchParams);
                          newParams.delete("pageTitle");
                          newParams.set("page", "0");
                          setSearchParams(newParams);
                        } else if (currentFilteredOptions.length === 1) {
                          // If exactly one result, select it
                          handleSelectPage(null, currentFilteredOptions[0]);
                        } else if (currentFilteredOptions.length > 1) {
                          // Multiple results but <= 1, show them as filter
                          setConfirmedSearchText(searchText.trim());
                          setSelectedOption(null);

                          const newParams = new URLSearchParams(searchParams);
                          newParams.delete("pageTitle");
                          newParams.set("page", "0");
                          setSearchParams(newParams);
                        }

                        setIsOpen(false);
                        event.preventDefault();
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ marginLeft: "12px" }} />
                        </InputAdornment>
                      ),
                    }}
                    size="small"
                  />
                )}
              />

              {/* site pages filter component called here  */}
              <SitePagesFilter {...tableProps} />
            </div>

            <div className="actions2">
              {!hasAssignPagesToGroupsPermission ? (
                <Button
                  disabled
                  variant="outlined"
                  color="secondary"
                  sx={{
                    fontSize: "0.875rem", // Default font size
                    "@media (max-width: 1200px)": {
                      fontSize: "0.5rem", // Font size for smaller viewports
                    },
                  }}
                >
                  ASSIGN PAGE GROUP
                </Button>
              ) : (
                <Button
                  disabled={isAssignPageGroupEnable}
                  onClick={openAssignPageGroupDialog}
                  data-tracker="6"
                  variant="outlined"
                  color="secondary"
                  sx={{
                    fontSize: "0.875rem", // Default font size
                    "@media (max-width: 1200px)": {
                      fontSize: "0.5rem", // Font size for smaller viewports
                    },
                  }}
                >
                  ASSIGN PAGE GROUP
                </Button>
              )}
              {!hasCreatePagePermission ? (
                <Button
                  disabled
                  variant="contained"
                  color="secondary"
                  sx={{
                    fontSize: "0.875rem", // Default font size
                    "@media (max-width: 1200px)": {
                      fontSize: "0.5rem", // Font size for smaller viewports
                    },
                  }}
                >
                  Create New Page
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handelCreatePagePopUp}
                  sx={{
                    fontSize: "0.875rem", // Default font size
                    "@media (max-width: 1200px)": {
                      fontSize: "0.5rem", // Font size for smaller viewports
                    },
                  }}
                  data-tracker="14"
                >
                  Create New Page
                  <AddIcon
                    sx={{
                      fontSize: "0.875rem", // Default font size
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem", // Font size for smaller viewports
                      },
                    }}
                  />
                </Button>
              )}
            </div>
          </div>
          <div
            className={`card-bulk-actions-1-mediu1 ${
              isOpen ? "table-disabled" : ""
            }`}
          >
            <CustomTable {...tableProps} />
          </div>
        </div>
      </div>
      <div style={{ width: "100%", marginTop: "10px" }}>
        <Dialog
          open={openCreateNewPage}
          onClose={handleClose}
          fullWidth
          maxWidth="md"
        >
          <div
            style={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Create New Page
            </DialogTitle>
            {/* {errorValidate ? <Alert severity="warning" sx={{marginBottom:"10px"}} >{errorValidate}</Alert> : "" } */}
            <div style={{ marginBottom: "20px", display: "flex", gap: "20px" }}>
              <div style={{ flex: 1 }}>
                <TextField
                  required
                  fullWidth
                  id="pageTitle"
                  label="Page Title"
                  value={pageTitle}
                  onChange={(e) => setPageTitle(e.target.value)}
                  color="secondary"
                />
              </div>
            </div>
            <div style={{ marginBottom: "20px", display: "flex", gap: "20px" }}>
              <div style={{ flex: 1 }}>
                <InputLabel id="pageGroups-label" sx={{ mb: 1 }}>
                  Page Group *
                </InputLabel>
                <Select
                  required
                  fullWidth
                  labelId="pageGroups-label"
                  id="pageGroups"
                  value={pageGroup}
                  onChange={(e) => setPageGroup(e.target.value)}
                  color="secondary"
                >
                  {pageGroups
                    ?.filter((group: any) => group.active === true)
                    .map((option: PageGroup) => (
                      <MenuItem
                        key={option.shared_uid}
                        value={option.shared_uid}
                      >
                        {option.group_name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </div>
            <div style={{ marginBottom: "15px" }}>All fields are mandatory</div>
            <Box
              component="div"
              sx={{
                p: 1,
                borderRadius: 1,
                backgroundColor: "#F7EEF9",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <InfoOutlinedIcon
                  style={{ marginRight: "12px", fontSize: "20px" }}
                  color="secondary"
                />
                <Typography variant="h6" color="#9C27B0" fontSize={16}>
                  PLEASE NOTE:
                </Typography>
              </div>
              <Typography color="#9C27B0" sx={{ paddingLeft: 4 }}>
                All pages are created with a default "Draft" status. You will be
                able to change that once the page is created.
              </Typography>
            </Box>
          </div>
          <DialogActions sx={{ padding: "10px 20px 20px" }}>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <Button
              onClick={() => validate()}
              variant="contained"
              color="secondary"
              endIcon={<AutoFixHighIcon />}
              data-tracker="15"
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* Assign page group Dialog */}
      {/*  <AssignPageGroup isCheckboxCheckedArray={isCheckboxCheckedArray} setIsCheckboxCheckedArray={setIsCheckboxCheckedArray} setRefresh={setRefresh} setPageDetails={setPageDetails} assignPageGroup={assignPageGroup} pageGroupForAssign={pageGroupForAssign} pageGroups={pageGroups} pageDetails={pageDetails} assignPageGroupDialogOpen={assignPageGroupDialogOpen} setAssignPageGroupDialogOpen={setAssignPageGroupDialogOpen} /> */}
      {/* Error Dialog for Duplicate Page Title */}
      <Dialog
        open={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Duplicate Page Title</DialogTitle>
        <DialogContent>
          <Typography>
            A page with this page title already exists or there was an error
            while creating the page. Do you want to retry?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowErrorDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleRetry} color="secondary" variant="contained">
            Retry
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
